import CommonTips, { CommonTipsActionType, CommonTipsType } from '@com/common-tips';
import i18n from '@i18next/i18n';
import { MutationSource } from '@tencent/slide-sdk-model';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

export class MutationListener {
    public constructor() {
        SlideDataServices.SDKDataServices.EventManager.promise().then(({ mutationEvents }) => {
            mutationEvents.onMutationError((error, stage, source) => {
                if (source === MutationSource.Editor) {
                    CommonTips.getInstance().hide();
                    const hasUnsentChanges = OnlineEditServices.CollaborationManager()?.getPersistent()
                        .getMutationsPacks().length;
                    let commonTipsConfig = {};
                    if (hasUnsentChanges) {
                        commonTipsConfig = {
                            message: i18n.t('更新数据异常，本地存在未保存的数据'),
                            commonTipsType: CommonTipsType.ERROR,
                            onlyShowOne: true,
                            actionType: CommonTipsActionType.HOWTODEAL,
                            callBack: async (actionType: number, fn?: any) => {
                                if (actionType === CommonTipsActionType.CREATE_COPY_DOC) {
                                    fn(false);
                                }
                            },
                        };
                    } else {
                        commonTipsConfig = {
                            message: i18n.t('更新数据异常'),
                            commonTipsType: CommonTipsType.ERROR,
                            onlyShowOne: true,
                            actionType: CommonTipsActionType.REFRESH,
                        };
                    }
                    CommonTips.getInstance().show(commonTipsConfig);
                }
            });
        });
    }
}
